import React, { Component } from 'react'
import '../css/App.css'

class PartyFilter extends Component{
   
    render(){
        const {parties,curParty,clearPartyFilter, getPartyResults} = this.props
    
        return(
            <div className='row partyWrap'>
                <label style={{position:'relative', top:'18px', fontSize:'small'}}>Filter by Party</label>
                <div className="btn-group btn-group-toggle col-xs-12 col-sm-12 col-lg-10 partyHorizontal" data-toggle="buttons"  aria-label="Filters" style={{paddingLeft:'10px'}}>
                    {parties.map((party, index, arr) => (
                        
                            <label  key={party.PartyCode}   style={{padding: '3px',backgroundColor: (curParty == party.PartyCode ? party.ColorCode : ''), borderBottomColor: party.ColorCode, color:(curParty == party.PartyCode ? 'white': party.ColorCode ) }} className={curParty == party.PartyCode ? 'party-button active' : 'party-button'} onClick={(e) => getPartyResults(e, party.PartyCode)} >
                                <input type="radio" name="curParty" value={party.PartyCode} autoComplete="off" hidden / > {party.PartyName}
                            </label>
                        
                        ))
                    }
                   <a id='resetFilter' href='' className='btn btn-link' style={{paddingLeft: '3px',position: 'relative',top: '0px', fontSize:'13px', visibility:curParty?'visible':'hidden'}} onClick={clearPartyFilter} >Clear Filter</a>
                </div>
                <div className="btn-group-vertical btn-group-toggle col-xs-12 col-sm-12 col-lg-10 partyVertical" data-toggle="buttons"  aria-label="Filters" style={{paddingLeft:'0px', paddingBottom:'10px', paddingTop:'10px'}} >
                    {parties.map((party, index, arr) => (
                        <label key={party.PartyCode} className={curParty == party.PartyCode ? "btn btnwhite-primary-v active":"btn btnwhite-primary-v"} style={{ borderBottomWidth:'3px', paddingBottom:'7px', borderBottomColor: party.ColorCode, backgroundColor: (curParty == party.PartyCode ? party.ColorCode : ''), color: curParty == party.PartyCode ?  'white' : party.ColorCode}} onClick={(e) => getPartyResults(e, party.PartyCode)} >
                            <input type="radio" name="curParty" value={party.PartyCode} autoComplete="off"/ > {party.PartyName}
                        </label>
                        ))
                    }
                    {curParty && <a id='resetFilter' href='' className='btn btn-link' style={{paddingLeft: '3px',position: 'relative',top: '0px', fontSize:'13px'}} onClick={clearPartyFilter} >Clear Filter</a>}
                </div>
            </div>
        )
    }
}

export default PartyFilter


// WEBPACK FOOTER //
// ./src/components/PartyFilter.js